import Utils from '@/common/utils/utils';
import HeaderPublicKnowledge from '@/component/common/layout/header/HeaderPublicKnowledge';
import serviceFactory from '@/service/ServiceFactory';
import React, { Suspense, useEffect, useState, useRef } from 'react';
import { Route, useParams } from 'react-router-dom';
import Constant from '@/common/constant/Constant';
import { getPublicAPI } from '@/service/publicService';
import ChatBoxComponent from '@/component/publicPages/chatBot/ChatBoxComponent';
import LoadingPanel from '@/component/common/LoadingPanel';
import IPRestrictionMessage from '@/component/publicPages/publicKnowledge/IPRestrictionMessage';
import './PublicKnowledgeLayout.css';
// import './public-knowledge-default-style.css';

const WrapLayout = ({ children }) => {
    const [infoSettingPublicKnowledge, setInfoSettingPublicKnowledge] = useState({});
    const { subDomain, projectId } = useParams();
    const [isLoadedCss, setIsLoadingCss] = useState(false);
    const [isPublicAccess, setPublicAccess] = useState(true);


    const [isDisplayChatBot, setIsDisplayChatBot] = useState(false);
    const scriptRef = useRef();
    useEffect(() => {
        let isMounted = true;
        if (isMounted) {
            (async () => {
                let params = {
                    getApiType: Constant.GET_API_PUBLIC_TYPE.PREPARE_DATA_SETTING_PUBLIC_KNOWLEDGE,
                    subDomain: subDomain,
                    projectAlias: projectId
                };
                let result = await getPublicAPI(children.props?.API, params);

                setIsDisplayChatBot(result.success)
                let payload = Utils.convertJSONDataToObject(result.payload);
                if (result.success) {
                    setPublicAccess(payload?.projectDetail?.isPublicAccess);
                }

                setInfoSettingPublicKnowledge(payload);
                if (payload?.publicKnowledgeSiteSetting?.gaScript) {
                    // console.log('--------scriptRef.current.firstChild', scriptRef.current.firstChild)
                    // while (scriptRef.current.firstChild) {
                    //     scriptRef.current.removeChild(scriptRef.current.lastChild);
                    // }
                    if (scriptRef?.current?.firstChild === null) {
                        const node = document.createRange().createContextualFragment(payload?.publicKnowledgeSiteSetting?.gaScript);
                        // trick init GA script after render meta title
                        scriptRef?.current?.appendChild(node)
                        // setTimeout(() => scriptRef?.current.appendChild(node), 100);
                    }

                } else {
                    while (scriptRef?.current?.firstChild) {
                        scriptRef?.current?.removeChild(scriptRef.current?.lastChild);
                    }
                }

                let checkElement = document.getElementById('public-knowledge-css');
                if (!checkElement) {
                    const versionCss = payload?.publicKnowledgeSiteSetting?.versionPublicKnowledgeStyleCss
                    const keyFile = Utils.genKeyFileCss(payload.corporationId, payload.projectId, versionCss);
                    let linkS3 = ''
                    if (!keyFile) {
                        linkS3 = `${process.env.REACT_APP_CLOUD_FRONT_URL}/public/assets/public-knowledge-default-style.css`;
                    } else {
                        linkS3 = `${process.env.REACT_APP_CLOUD_FRONT_URL}/public/${keyFile}`;
                    }
                    const linkElement = document.createElement("link");
                    linkElement.setAttribute("rel", "stylesheet");
                    linkElement.setAttribute("type", "text/css");
                    linkElement.setAttribute("id", "public-knowledge-css");
                    linkElement.setAttribute(
                        "href",
                        linkS3
                    );
                    document.head.appendChild(linkElement);
                    setIsLoadingCss(true)
                }
                children.props.setReloadPublicKnowledgeAssets(false);
            })();
        }

        return () => {
            isMounted = false;
        }
    }, [subDomain, projectId, children.props.reloadPublicKnowledgeAssets]);

    if (!isLoadedCss) {
        return (<LoadingPanel isLoading={true} />)
    }

    return (
        <div className="wrapContent-public-knowledge">
            <header className="header-public-knowledge">
                <div className="container-public-knowledge header-layout">
                    <Suspense>
                        <HeaderPublicKnowledge
                            {...children.props}
                            infoSettingPublicKnowledge={
                                infoSettingPublicKnowledge?.publicKnowledgeSiteSetting
                            }
                            publicKnowledgeProjectId={infoSettingPublicKnowledge?.projectId}
                            iframeSetting={infoSettingPublicKnowledge?.iframeSetting}
                            isPublicAccess={isPublicAccess}
                        />
                    </Suspense>
                </div>
            </header>

            <section className="main-public-knowledge">
                <Suspense>
                    {isPublicAccess ? children : (
                        <div className="container-ip-restriction">
                            <div className="ip-restriction-message-pks">
                                <IPRestrictionMessage />
                            </div>
                        </div>
                    )}
                </Suspense>
            </section>
            {isPublicAccess &&
                <footer>
                    {isDisplayChatBot && <ChatBoxComponent projectId={projectId} subDomain={subDomain} publicKnowledgeSetting={infoSettingPublicKnowledge?.publicKnowledgeSiteSetting} API={children.props?.API} />}
                    {Utils.isEmptyString(infoSettingPublicKnowledge?.publicKnowledgeSiteSetting?.footer) ? (
                        <></>
                    ) : (
                        <div
                            dangerouslySetInnerHTML={{
                                __html: infoSettingPublicKnowledge?.publicKnowledgeSiteSetting?.footer
                            }}
                        ></div>
                    )}
                </footer>}
            <div style={{ display: 'none' }} ref={scriptRef}></div>
        </div>
    );
};

const PublicKnowledgeLayoutRoute = ({ component: Component, ...rest }) => {
    return (
        <Route
            {...rest}
            render={props => (
                <WrapLayout>
                    <Component {...rest} {...props} />
                </WrapLayout>
            )}
        />
    );
};

export default serviceFactory(PublicKnowledgeLayoutRoute);
